module.exports = function () {
    $(function () {
        var wrapper = $('.wrapper');
        var footer = $('footer#main-footer');

        function initWrapper() {
            var min = 'calc(100% - ' + Math.round(footer.height()) + 'px)';
            wrapper.css({
                minHeight: min
            });
        }
        $(document).ready(initWrapper);
        $(window).resize(initWrapper);
    })
}